import { Box, VStack } from '@chakra-ui/react'
import { useAudioCapture } from '@hooks'
import { trackEvent } from '@lib/clinician-tracking'
import React from 'react'
import { MicrophonePermissionsModal } from '../mic-permissions-modal'
import { SessionControlsFooter } from '../session-controls-footer'
import { SettingsDialog } from '../settings-dialog'
import { RecordingSettings } from './recording-settings'

export const RecordingPanel = ({
  isMobileBreakpoint,
  isMuted,
  isTabAudioStreamOpen,
  recordingDuration,
  isStopRecordingAfterEnabled,
  recordingStartedAt,
  onOpenEndModal,
  showPermissionModal,
  handlePermissionModalClose,
  startContentShare,
  isDictation,
  showRecordingLengthWarning
}: {
  isMobileBreakpoint: boolean
  isMuted: boolean
  isTabAudioStreamOpen: boolean
  recordingDuration: number
  isStopRecordingAfterEnabled: boolean
  recordingStartedAt: string
  onOpenEndModal: () => void
  showPermissionModal: boolean
  handlePermissionModalClose: () => void
  startContentShare: () => void
  isDictation: boolean
  showRecordingLengthWarning: boolean
}) => {
  const { toggleMute, showMicWarning, showTabMicWarning, setActiveWarning } =
    useAudioCapture()

  const [isSettingsOpen, setIsSettingsOpen] = React.useState(false)

  const handleMuteToggle = () => {
    toggleMute()
  }

  const handleSettingsClick = () => {
    trackEvent('Session -> Clicked Settings')
    setIsSettingsOpen(true)
  }

  return (
    <VStack
      data-testid="session-timer-controls-container"
      justifyContent="center"
      color="white"
      height="100%"
      minWidth="320px"
      textAlign="center"
      display="flex"
    >
      <Box flex={isMobileBreakpoint ? '5' : '1'} />
      <RecordingSettings
        isMobileBreakpoint={isMobileBreakpoint ?? false}
        isMuted={isMuted}
        isTabAudioStreamOpen={isTabAudioStreamOpen}
        recordingDuration={recordingDuration}
        isStopRecordingAfterEnabled={isStopRecordingAfterEnabled}
        recordingStartedAt={recordingStartedAt ?? ''}
      />
      <SessionControlsFooter
        isMuted={isMuted}
        onMuteToggle={handleMuteToggle}
        onSettingsClick={handleSettingsClick}
        onEndSession={onOpenEndModal}
        showRecordingLengthWarning={showRecordingLengthWarning}
        showMicWarning={showMicWarning}
        showTabMicWarning={showTabMicWarning}
        setActiveWarning={setActiveWarning}
      />
      <MicrophonePermissionsModal
        isOpen={showPermissionModal}
        onClose={handlePermissionModalClose}
      />
      <SettingsDialog
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
        onShareAudio={startContentShare}
        isDictation={isDictation}
      />
    </VStack>
  )
}
